import { TableBody } from '@mui/material';
import React from 'react';

import ArtworkRow from './ArtworkRow';

const TableArtworkCollectorBody = ({ listArtwork }) => {
  return (
    <TableBody>
      {listArtwork.map((artwork) => (
        <ArtworkRow
          key={artwork?.id}
          artwork={artwork}
        />
      ))}
    </TableBody>
  );
};

export default TableArtworkCollectorBody;
